"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const app_types_1 = require("pages/app.types");
const stockpile_types_1 = require("./stockpile.types");
const initialState = {
    isLoading: true,
    isError: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    mutationMode: false,
    dataItem: {
        id: '0',
        stockpile: '',
        description: '',
        target_lead_time: '',
        target_queue_time: '',
        target_lead_time_display: '',
        target_queue_time_display: '',
        is_active: {
            status: 'Active',
            value: true
        },
        created_by: '',
        created_date: new Date(),
        modified_by: '',
        modified_date: new Date()
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }]
    }
};
const stockpileReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [stockpile_types_1.stockpileTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [stockpile_types_1.stockpileTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates, dataGrid } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid,
            dataStates, isLoading: false });
    },
    [stockpile_types_1.stockpileTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, dataItem: dataItem ? dataItem : initialState.dataItem, mutationMode: mutationMode });
    },
    [stockpile_types_1.stockpileTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, isLoading: true, dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === dataItem.id)
                    return dataItem;
                return item;
            }) });
    },
    [stockpile_types_1.stockpileTypes.ON_DELETE]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.filter(item => item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id)) });
    },
    [stockpile_types_1.stockpileTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [stockpile_types_1.stockpileTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [stockpile_types_1.stockpileTypes.SET_ERROR]: (state, action) => {
        const { isError, errorCode, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isError, errorCode, errorMessage, isLoading: false });
    },
    [stockpile_types_1.stockpileTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload });
    }
});
exports.default = stockpileReducer;
